import React from "react";
import { AttributeInnerCardWrapper } from "./styles";
import { Ptag } from "components/core";
import { formatPlanOverviewValue } from "utlis/utils";

function AttributeInnerCard({ title, value, width, wholeData }) {

  return (
    // <AttributeInnerCardWrapper width={width}>
    //   <Ptag fontSize="10px">{title}</Ptag>
    //   <Ptag fontSize="14px" color="#4a4a4a" fontWeight="700" marginTop="10px">
    //     {formatPlanOverviewValue(value)}
    //   </Ptag>
    // </AttributeInnerCardWrapper>
    <div className="default-attributes-card-css">
      {/* <div class="spacing-css">
        <div>
          <span className="maternity-card-heading-css">
            {"heading"}
          </span>
        </div>
        <div className="gold-line-css" />
      </div> */}

      <div style={{
        display: "flex",
        flexDirection: "column",
        // marginTop: "16px",
        gap: "8px"
      }}>
        <span className='maternity-max-limit-heading'>
          {title}
        </span>
        <span className='maternity-max-limit-value'>
          {value}
        </span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", marginTop: "14px", gap: "8px" }}>
        <span className='maternity-max-limit-heading'>
          Remarks
        </span>
        <span className='maternity-max-limit-value'>
          {wholeData?.remarks ? wholeData.remarks : "-"}
        </span>
      </div>

    </div>
  );
}

export default AttributeInnerCard;
